module.exports = __webpack_public_path__ + "img/inter_corp_logo.9bbad8ec.png";